<script>
import PokerTableGmfSelektor from '@/components/PokerTable/PokerTableGmfSelektor'
import GmfInfo from '@/components/GameFormat/GmfSelektor/GmfInfo'

export default {
  name: 'GmfPreview',
  // mounted() {
  // this.$emit('gmfpreview:mounted')
  // },
  components: {
    PokerTableGmfSelektor,
    GmfInfo,
  },
  props: {
    gameformat: Object,
  }, 
 emits: ['gmfpreview:mounted'],
}
</script>

<template>
  <div class="gmf_preview">
    <slot></slot>
    <div
      class="gmf_preview_table-container"
      style="margin-top: 0.5em"
    >
      <PokerTableGmfSelektor
        class="gmfslctr_table"
        :gameformat
        style="
          background: var(--clr-black-0);
          border-radius: 4px;
          padding: 1em;
          font-size: 0.725em;
          min-height: 22em;
          --table-hor-height: 18em;
          --table-hor-min-height: 18em;
          --table-hor-min-width: 100%;
          --table-width: 38em;
          --table-ver-max-width: 32em;
          --table-ver-max-height: 42em;
          --clr-hero: var(--clr-hero-default);
          --clr-trainer_player_active: var(--clr-black-3);
          --clr-trainer_player_folded: var(--clr-black-1-2);
        "
      />
    </div>
    <GmfInfo
      style="margin-top: 1em"
      :gameformat
    />
  </div>
</template>

<style lang="scss" scoped>
.gmf_preview {
  --width: clamp(18em, 22em, calc(100vw - 6rem));
  max-width: var(--width);
  min-width: var(--width);
  &_table-container {
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    // min-height: 33rem;
  }
}
</style>
